import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Make sure Link is imported
import { collection, getDocs, query, orderBy, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './ExpensesPage.css';

const ExpensesPage = () => {
    const [allExpenses, setAllExpenses] = useState([]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    // REMOVED: No longer need state for the modal
    // const [isModalOpen, setIsModalOpen] = useState(false);

    // Fetching logic remains the same
    const fetchData = async () => {
        setLoading(true);
        try {
            const grnsRef = collection(db, "grns");
            const expensesRef = collection(db, "meals expenses");
            const [grnsSnapshot, expensesSnapshot] = await Promise.all([
                getDocs(query(grnsRef, orderBy("createdAt", "desc"))),
                getDocs(query(expensesRef, orderBy("createdAt", "desc")))
            ]);
            const purchaseRecords = grnsSnapshot.docs.map((doc, index) => ({
                id: doc.id, date: doc.data().purchaseDate,
                description: `Purchase - GRN_${String(grnsSnapshot.docs.length - index).padStart(4, '0')}`,
                category: 'Purchase', amount: doc.data().totalPurchasePrice, createdAt: doc.data().createdAt,
            }));
            const generalExpenses = expensesSnapshot.docs.map(doc => ({
                id: doc.id, date: doc.data().expenseDate, description: doc.data().expenseType,
                category: 'General Expense', amount: doc.data().amount, createdAt: doc.data().createdAt,
            }));
            const combinedRecords = [...purchaseRecords, ...generalExpenses];
            combinedRecords.sort((a, b) => b.createdAt.toDate() - a.createdAt.toDate());
            setAllExpenses(combinedRecords);
            const total = combinedRecords.reduce((sum, record) => sum + record.amount, 0);
            setGrandTotal(total);
        } catch (error) {
            console.error("Error fetching financial data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDeleteExpense = async (id) => {
        if (window.confirm("Are you sure you want to delete this general expense?")) {
            await deleteDoc(doc(db, "expenses", id));
            fetchData();
        }
    };
    
    const formatPrice = (price) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);

    return (
        <div className="list-container-expense">
            <div className="list-header-expense">
                <h1>All Expenses</h1>
                {/* UPDATED: Changed the button to a Link component */}
                <Link to="/expenses/add" className="add-expense-button">
                    Add General Expense
                </Link>
            </div>

            {loading ? <p>Loading Expenses...</p> : (
                <table className="expense-table">
                    <thead>
                        {/* Table structure remains the same */}
                        <tr>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>Amount</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allExpenses.map((record) => (
                            <tr key={`${record.category}-${record.id}`}>
                                <td>{record.date}</td>
                                <td>{record.description}</td>
                                <td><span className={`category-tag ${record.category.replace(' ', '-').toLowerCase()}`}>{record.category}</span></td>
                                <td>{formatPrice(record.amount)}</td>
                                <td className="actions-cell">
                                    {record.category === 'General Expense' && (
                                        <button onClick={() => handleDeleteExpense(record.id)} className="action-button delete">Delete</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="3" className="total-label">Grand Total</td>
                            <td className="total-amount">{formatPrice(grandTotal)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            )}
            {/* REMOVED: The conditional rendering of the modal is gone */}
        </div>
    );
};

export default ExpensesPage;